<template>
  <section>
    <form action v-on:submit.prevent="saveReport">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p>Guardar reporte</p>
        </header>
        <section class="modal-card-body" style="width: 600px">
          <b-field label="Fecha">
            <b-datepicker
              placeholder="Haga click para seleccionar..."
              icon="calendar-today"
              trap-focus
              required
              append-to-body
              v-model="date_report"
              :first-day-of-week="1"
              :day-names="daysOfTheWeek"
              :month-names="monthNames"
              icon-pack="fas"
            ></b-datepicker>
          </b-field>
          <b-field label="Observaciones">
            <b-input
              type="textarea"
              v-model="observations"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">
            Guardar reporte
          </button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>

import moment from "moment";
import { storeDailyReport } from '../../services/daily_report';
export default {
  props: ["getReports", "tableReportBedStateData", "tableReportBedCovidData"],
  data() {
    return {
      daysOfTheWeek: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      date_report: new Date(),
      observations: null,
    };
  },
  methods: {
    async saveReport() {
      // if (!this.tableReportBedStateData && !this.tableReportBedCovidData) {
      //   this.$buefy.dialog.alert({
      //     title: 'Error',
      //     message: 'Hay datos en el reporte que aún no han cargado, por favor volver a intentar.',
      //     type: 'is-warning',
      //     hasIcon: true,
      //     iconPack: 'fa',
      //   });
      //   return;
      // }
      this.$buefy.dialog.confirm({
        title: 'Validación',
        message: `¿Está seguro/a que desea guardar el reporte con fecha ${moment(this.date_report).format("YYYY-MM-DD HH:mm")}?`,
        type: 'is-warning',
        hasIcon: true,
        cancelText: 'Cancelar',
        confirmText: 'Continuar',
        onConfirm: async () => {
          const loader = this.$buefy.loading.open();
          try {
            await storeDailyReport(this.$http, {
              user_id: JSON.parse(localStorage.getItem("user")).id,
              observations: this.observations,
              report: JSON.stringify({
                tableReportBedStateData:this.tableReportBedStateData,
                tableReportBedCovidData: this.tableReportBedCovidData
              }),
              report_date: moment(this.date_report).format("YYYY-MM-DD HH:mm")
            });
            this.toast("Reporte creado exitosamente", "is-success");
          } catch (error) {
            console.log(error);
            this.toast("El reporte no se ha podido crear", "is-danger");
          }
          loader.close();
          this.$parent.close();
          this.getReports();
        }
      }); 
    },
  },
  mounted() {
    
  }
};
</script>

<style>
</style>